import commonConstant from '../../common/_commonConstant';
import { getCookieToken, checkTimeToRefreshToken } from '../../common/_commonFunction';
import { history } from '../../helpers';
import { fetchRefreshToken } from '../../actions';

export const fetchGetParkingStatus = (parkingID) => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/parkings/${parkingID}/parking-fee-summary`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
      });
      const data = await res.json();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }
      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.GET_PARKING_STATUS_SUCCESS,
          'data': data.data ? { ...data.data } : {},
          'dateTime': new Date(),
          'status': res.status,
          'errorMessage': null,
        });
      } else if (res.status === 400 && data.detail === commonConstant.trowErrorParkingNotFound) {
        return dispatch({
          'type': commonConstant.GET_PARKING_STATUS_FAILURE,
          'data': null,
          'dateTime': new Date(),
          'status': res.status,
          'errorMessage': data.detail,
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
      return dispatch({
        'type': commonConstant.GET_PARKING_STATUS_FAILURE,
        'data': null,
        'dateTime': new Date(),
        'status': res.status ? res.status : res,
        'errorMessage': data.detail ? data.detail : data,
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.GET_PARKING_STATUS_FAILURE,
        'data': null,
        'dateTime': new Date(),
        'status': err.status ? err.status : err,
        'errorMessage': null,
      });
    }
  }
);

export const fetchGetParkingStatusById = (parkingID, vehicleType) => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/parkings/${parkingID}${vehicleType ? `?vehicleType${vehicleType}` : ''}`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
      });
      const data = await res.json();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }
      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.GET_PARKING_STATUS_BY_ID_SUCCESS,
          'data': data.data ? { ...data.data, 'payment': data.data.payment ? data.data.payment.reverse() : null } : {},
          'dateTime': new Date(),
          'status': res.status,
          'errorMessage': null,
        });
      } else if (res.status === 400) {
        return dispatch({
          'type': commonConstant.GET_PARKING_STATUS_FAILURE,
          'data': null,
          'dateTime': new Date(),
          'status': res.status,
          'errorMessage': data.detail,
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
      return dispatch({
        'type': commonConstant.GET_PARKING_STATUS_BY_ID_FAILURE,
        'data': null,
        'dateTime': new Date(),
        'status': res.status ? res.status : res,
        'errorMessage': data.detail ? data.detail : data,
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.GET_PARKING_STATUS_BY_ID_FAILURE,
        'data': null,
        'dateTime': new Date(),
        'status': err.status ? err.status : err,
        'errorMessage': null,
      });
    }
  }
);

export const fetchCreateParking = formCreateParking => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/parkings/parking-by-users`, {
        'method': 'POST',
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
        'body': JSON.stringify(formCreateParking),
      });
      const data = await res.json();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }
      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.CREATE_PARKING_SUCCESS,
          'data': data.data ? { ...data.data } : {},
          'dateTime': new Date(),
          'status': res.status,
          'errorMessage': null,
        });
      } else if (res.status === 400 && data.detail === commonConstant.trowErrorCreateParkingAlreadyExist) {
        return dispatch({
          'type': commonConstant.CREATE_PARKING_FAILURE,
          'data': null,
          'dateTime': new Date(),
          'status': res.status,
          'errorMessage': data.detail,
        });
      } else if (res.status === 400 && data.detail === commonConstant.throwErrorParkingZoneNotAllow) {
        return dispatch({
          'type': commonConstant.CREATE_PARKING_FAILURE,
          'data': null,
          'dateTime': new Date(),
          'status': res.status,
          'errorMessage': data.detail,
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
      return dispatch({
        'type': commonConstant.CREATE_PARKING_FAILURE,
        'data': null,
        'dateTime': new Date(),
        'status': res.status ? res.status : res,
        'errorMessage': data.detail ? data.detail : data,
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.CREATE_PARKING_FAILURE,
        'data': null,
        'dateTime': new Date(),
        'status': err.status ? err.status : err,
        'errorMessage': null,
      });
    }
  }
);

export const fetchUpdateStatusCarExit = (parkingID, formUpdateStatus) => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/parkings/${parkingID}`, {
        'method': 'PUT',
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
        'body': JSON.stringify(formUpdateStatus),
      });
      const data = await res.json();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }
      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.UPDATE_STATUS_CAR_EXIT_SUCCESS,
          'data': data.data ? { ...data.data } : {},
          'dateTime': new Date(),
          'status': res.status,
          'errorMessage': null,
        });
      } else if (res.status === 400) {
        return dispatch({
          'type': commonConstant.GET_PARKING_STATUS_FAILURE,
          'data': null,
          'dateTime': new Date(),
          'status': res.status,
          'errorMessage': data.detail,
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
      return dispatch({
        'type': commonConstant.UPDATE_STATUS_CAR_EXIT_FAILURE,
        'data': null,
        'dateTime': new Date(),
        'status': res.status ? res.status : res,
        'errorMessage': data.detail ? data.detail : data,
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.UPDATE_STATUS_CAR_EXIT_FAILURE,
        'data': null,
        'dateTime': new Date(),
        'status': err.status ? err.status : err,
        'errorMessage': null,
      });
    }
  }
);
